import React from "react";

export default function HardcodedEndColumnTHs() {
  return (
    <>
      <th className="c-parts-listing__table-header"></th>
    </>
  );
}
